module.exports = __webpack_public_path__ + "static/media/dc_qr.09856a73.png";